import { render, staticRenderFns } from "./rate-change-table.vue?vue&type=template&id=1956ec4f&scoped=true&"
import script from "./rate-change-table.vue?vue&type=script&lang=js&"
export * from "./rate-change-table.vue?vue&type=script&lang=js&"
import style0 from "./rate-change-table.vue?vue&type=style&index=0&id=1956ec4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956ec4f",
  null
  
)

export default component.exports